import { collection, doc, getDocs, setDoc, deleteDoc, updateDoc, addDoc } from 'firebase/firestore';
import { db } from '@/config/firebase';

export interface CriteriaIndicator {
    id: string;
    description: string;
    isActive: boolean;
    selfEvaluationQuestion?: string;
    leaderEvaluationQuestion?: string;
    scaleId?: string;
}

export interface CriteriaBehavior {
    id: string;
    description: string;
    indicators: CriteriaIndicator[];
}

export type CriteriaGroupType = 'STANDARD' | 'PROLOGUE' | 'EPILOGUE';

export interface CriteriaGroup {
    id?: string;
    description: string;
    type?: CriteriaGroupType;
    behaviors: CriteriaBehavior[];
}

const COLLECTION_NAME = 'performance_criteria_groups';

export const getCriteriaGroups = async (): Promise<CriteriaGroup[]> => {
    try {
        const snapshot = await getDocs(collection(db, COLLECTION_NAME));
        return snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        } as CriteriaGroup));
    } catch (error) {
        console.error("Error getting criteria groups:", error);
        throw error;
    }
};

export const saveCriteriaGroup = async (group: CriteriaGroup): Promise<void> => {
    try {
        if (group.id) {
            // Update existing
            const docRef = doc(db, COLLECTION_NAME, group.id);
            await setDoc(docRef, group); // setDoc with merge? No, we want to replace arrays.
        } else {
            // Create new
            const docRef = await addDoc(collection(db, COLLECTION_NAME), group);
            // No need to return ID unless called needs it, but Promise<void> is fine for now
        }
    } catch (error) {
        console.error("Error saving criteria group:", error);
        throw error;
    }
};

export const deleteCriteriaGroup = async (id: string): Promise<void> => {
    try {
        await deleteDoc(doc(db, COLLECTION_NAME, id));
    } catch (error) {
        console.error("Error deleting criteria group:", error);
        throw error;
    }
};
